export default {
  'Please select an output format': 'Alstublieft selecteer een uitvoerformaat',
}